import React, { Component } from 'react';
import Axios from 'axios';
import cachios from 'cachios'
import { BASE } from "../api/api";
import { Link } from 'react-router-dom'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { List } from 'react-content-loader'
import LoginModal from '../login/loginmodal';

class conference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 15,
            offset: localStorage.getItem('pagenum') ? JSON.parse(localStorage.getItem('pagenum')) : 0,
            next: false,
            prev: false,
            loginpopup: false,
            search:''
        };
    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    pagestore(id, redirect_link) {
        let dt = localStorage.getItem('token');
        if (redirect_link && (dt == null || !dt)) {
            this.setState({
                loginpopup: true,
                pagination: false,
                link_redirect: true,
                redirect_link: redirect_link
            })
        }
        else if (dt && dt != null) {
            this.setState({
                login: true,
            })
        }
        localStorage.removeItem('pagenum');
        localStorage.setItem('pagenum', JSON.stringify(id))

    }


    //Next/previous click function
    handlePageClick = data => {
        console.log(data, 'offset')

        let dt = localStorage.getItem('token');
        if (data === 'next' && this.state.next === true) {
            if (dt && dt != null) {
                this.setState({
                    conferences: '',
                })
                this.apicall(this.state.offset + this.state.limit,this.state.search)
                this.setState({
                    offset: this.state.offset + this.state.limit
                })
                console.log(this.state.offset, 'offset in api')
            }
            else {
                this.setState({
                    loginpopup: true,
                    // offset: this.state.offset + this.state.limit,
                    pagination: true,
                    link_redirect: false
                })
            }
        }
        else if (data === 'prev' && this.state.prev === true) {
            this.setState({
                conferences: '',
            })
            this.setState({
                offset: this.state.offset - this.state.limit
            })
            this.apicall(this.state.offset - this.state.limit,this.state.search)
        }


    };
    componentWillMount() {
        localStorage.removeItem('pagenum')

        let dt = localStorage.getItem('token')
        if (!dt || dt == null) {
            this.setState({ login: true })
        }
        else {
            this.setState({ login: true })
        }
        this.setState({

            conferences: undefined
        })

        this.apicall(this.state.offset,this.state.search)

    }

    getHighlightedText(text) {
        // Split on higlight term and include term into parts, ignore case
        if (this.state.search) {
            let parts = text.split(new RegExp(`(${this.state.search})`, 'gi'));
            return <div className="myspan"> {parts.map((part, i) =>
                <span key={i} style={part.toLowerCase() === this.state.search.toLowerCase() ? { backgroundColor: 'yellow', display: 'inline' } : {}}>
                    {part}
                </span>)
            } </div>;
        }
        else {
            return (text)
        }
    }

    offset(e){
        this.setState({
            offset:0
        })
    }
  
    apicall(id,contains)
    
       {
        this.setState({
            search:contains,
            conferences:''
        })
        this.topFunction();
        localStorage.removeItem('pagenum')
        //HIDE/SHOW  previous button
        if (id <= 0) {
            this.setState({
                prev: false,
            })
        }
        else {
            this.setState({
                prev: true
            })
        }
        
        Axios.get(BASE+'jsonapi/node/submit_for_work?filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Conferences&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]='+contains+'&page[limit]='+this.state.limit+'&page[offset]='+(id+this.state.limit)+'&sort=-created')

            .then((data) => {
                console.log(data.data, 'next')
                //HIDE/SHOW  NEXT button
                if (data.data.data.length === 0) {
                    this.setState({
                        next: false,
                    })
                }
                else {
                    this.setState({
                        next: true
                    })
                }
            })
            cachios.get(BASE+'jsonapi/node/submit_for_work?filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Conferences&filter[title][condition][path]=title&filter[title][condition][path]=title&filter[title][condition][operator]=CONTAINS&filter[title][condition][value]='+contains+'&page[limit]='+this.state.limit+'&page[offset]='+id+'&sort=-created', {
                ttl: 500 /* seconds */,
                })
            .then((datz_thesis) => {

                this.setState({
                    conferences: datz_thesis.data.data
                })
            })
            .catch(error => console.log(error.response));

    }
    render() {
        return (
            <div className='formrea yourwork sub_work'>
                <div onClick={() => this.setState({ loginpopup: false })} style={{ display: this.state.loginpopup ? '' : 'none', zIndex: 11 }} className='bgoverlay'></div>
                <Header />
                <div>
                    <div style={{ display: this.state.loginpopup ? '' : 'none' }} className='loginmodal'>
                        <div onClick={() => this.setState({ loginpopup: false })} className="login_modal_overlay"></div>
                        <div className="login_modal_wrpr">
                        <LoginModal isLoginTrue={(e) => this.loginTrue(e)} />
                        </div>
                        
                    </div>
                </div>

                <div className="listing">


                    <div className="page-title">
                        <div className="title-wrapper">
                        <div className="container gloss_container">
                                    <div>
                                        <h1 className="page-header">Conferences</h1>
                                    </div>
                                    <div className="search_input" style={{ alignSelf: 'center', zIndex: this.state.inputhide == true ? -1 : 0 }}>

                                        <input type="text" placeholder="Search " name="search" onChange={(e) =>{ this.apicall(this.state.offset,e.target.value);this.offset(e)}} maxLength={16} />
                                        <div className="search_logo" onClick={() => this.apicall(this.state.offset,this.state.search)}></div>
                                    </div>
                                
                            
                            </div>
                               
                            </div>
                        </div>
                    <div className="main-content">
                        <div className="container">
                            <div className="row">
                                <div className="region region-content">
                                    <div className="listings">
                                        {this.state.conferences ?
                                            <div className="mission">
                                                {this.state.conferences.map((inst, index) => {
                                                    return (
                                                        <div>
                                                            <div className="title">
                                                                {this.state.login === true ? (
                                                                    <span className="field-content">
                                                                        <Link onClick={() => this.pagestore(this.state.offset, '/conf_desc/' + `${inst.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${inst.attributes.drupal_internal__nid}`)} to={{ pathname: '/conf_desc/' + `${inst.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${inst.attributes.drupal_internal__nid}`, state: { dat_arr: inst.attributes } }}>{inst.attributes.title}</Link>
                                                                    </span>
                                                                ) : (
                                                                        <span className="field-content">
                                                                            <a onClick={() => this.pagestore(this.state.offset, '/conf_desc/' + `${inst.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${inst.attributes.drupal_internal__nid}`)} >{this.getHighlightedText(inst.attributes.title)}</a>
                                                                        </span>
                                                                    )}
                                                            </div>

                                                        </div>
                                                    )
                                                })}

                                            </div> : <List />

                                        }


                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                {this.state.conferences && (this.state.prev || this.state.next) ?

                    <ul className="pagination">
                        <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
                            <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                        <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                    </ul>

                    : ''}
                <Footer />
            </div>


        )
    }

}

export default conference;